/* prettier-ignore */

import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, ElementRef, inject, signal, ViewChild } from '@angular/core';
import { ChatInputComponent } from './chatInput/chatInput.component';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { DataChatService } from 'src/chatbot/service/dataChat.service';
import { SendButtonComponent } from './buttons/sendButton/sendButton/sendButton.component';
import { CancelButtonComponent } from './buttons/cancelButton/cancelButton.component';
import { SendMessageService } from 'src/chatbot/service/sendMessage.service';
import { TranslateModule } from '@ngx-translate/core';
import { InfoIconComponent } from 'src/chatbot/icons/info-icon.component';
import { LinkIconComponent } from 'src/chatbot/icons/link-icon.component';
import { VoiceButtonComponent } from './buttons/voiceButton/voiceButton.component';
import { ModalController } from '@ionic/angular';
import { ChatBotInfoComponent } from '../chatBotInfo/chatBotInfo.component';
import { RecordAudioHandlerService } from 'src/chatbot/service/recordAudioHandler.service';
import { WebSocketService } from 'src/chatbot/service/webSocket.service';
import { PlayAudioHandlerService } from 'src/chatbot/service/playAudioHandler.service';
import { LocalFillerPhrasesService } from 'src/chatbot/service/localFillerPhrases.service';

@Component({
  selector: 'chat-input-form',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslateModule,
    ChatInputComponent,
    SendButtonComponent,
    CancelButtonComponent,
    InfoIconComponent,
    LinkIconComponent,
    VoiceButtonComponent
  ],
  templateUrl: './chatInputForm.component.html',
  styleUrl: './chatInputForm.component.scss',
  changeDetection: ChangeDetectionStrategy.Default,
})

export class ChatInputFormComponent {
  @ViewChild('waveformCanvas', { static: true }) waveformCanvas!: ElementRef<HTMLCanvasElement>;
  
  private webSocketService = inject(WebSocketService)
  private recordService = inject(RecordAudioHandlerService);
  private playService = inject(PlayAudioHandlerService);
  private phrasesFiller = inject(LocalFillerPhrasesService);
  
  private modalController = inject(ModalController)
  private fb = inject(FormBuilder);
  public dataChat = inject(DataChatService);
  public sendMessage = inject(SendMessageService);
  public chatForm: FormGroup;

  public isRecording = computed(() => this.recordService.isRecording());
  public isStreaming = computed(() => this.dataChat.isStreaming());
  public isPlaying = computed(() => this.playService.isPlaying());
  public isPlayingWelcome = computed(() => this.phrasesFiller.isPlayingWelcome());
  public allowSendAudio = computed(() => this.dataChat.allowSendAudio());
  private modal: any;

  constructor() {
    this.chatForm = this.fb.group({
      userInput: ['', Validators.required],
    })
  }
  
  handleSubmit() {
    const selectedImage = this.dataChat.selectedImage();
    const text = this.chatForm.value.userInput;

    if (!selectedImage && (!text || text.trim() === "")){
      this.chatForm.get('userInput')?.setValue(null);
      return;
    }

    if (selectedImage) {
      console.log("Sending selected image")
      this.sendMessage.sendImageMessage(selectedImage, text);
      this.dataChat.selectedImage.set(null);
      this.dataChat.imagePreviewUrl.set(null);
    } else {
      this.sendMessage.sendMessageWebSocket(text);
    }

    this.chatForm.reset();
    this.dataChat.inputText.set(null)
  }

  handleReceivedData(event) {
    switch (event) {
      case 'START':
        this.handleStart();
        break;
      case 'STOP':
        this.handleRecordingStop();
        break;
    }
  }

  async openModal() {
    if (this.modal)
      return;

    this.modal = await this.modalController.create({
      component: ChatBotInfoComponent,
      cssClass: ['chatBotModal', 'ion-disable-focus-trap'],
      componentProps: {},
    });
    await this.modal.present();
    await this.modal.onDidDismiss();
    this.modal = null;
  }

  goToiUrban() {
    window.open('https://iurban.es/', "_blank");
  }

  handleStart() {
    const waves = this.waveformCanvas?.nativeElement;
    this.recordService.startRecording(waves);
  }

  getCanvasWidth(form) {
    return form.offsetWidth - 100;
  }

  handleStreamingStop() {
    this.dataChat.abortSignal().abort();
    this.webSocketService.cancelCompletion();
  }

  handleRecordingStop() {
    // this.webSocketService.enableLoader();
    this.recordService.stopRecording()
  }

  handleStopPlaying() {
    this.dataChat.abortSignal().abort();
    this.playService.stopNow();
  }

}
